import { IDanhSachHoanTotNghiepViewModel } from "../../../model/response/xet-tot-nghiep/IDanhSachHoanTotNghiepViewModel";
import { IXetTotNghiepLanXet } from "../../../model/response/xet-tot-nghiep/IXetTotNghiepLanXet";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachHoanTotNghiepActionsObj = {
    SHOW_MODAL: {} as IXetTotNghiepLanXet,
    CLOSE_MODAL: undefined,

    LOAD_DA_THEM_START: 0,
    LOAD_DA_THEM_SUCCESS: [] as IDanhSachHoanTotNghiepViewModel[],
    LOAD_DA_THEM_ERROR: "",

    LOAD_CHUA_THEM_START: 0,
    LOAD_CHUA_THEM_SUCCESS: [] as IDanhSachHoanTotNghiepViewModel[],
    LOAD_CHUA_THEM_ERROR: "",

    ADD_START: {} as { id_xet_tot_nghiep: number, id_svs: string[], ly_do?: string },
    ADD_SUCCESS: undefined,
    ADD_ERROR: "",

    DELETE_START: {} as { id_xet_tot_nghiep: number, ids: number[] },
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eDanhSachHoanTotNghiepActionIds = generateActionTypeIds(eDanhSachHoanTotNghiepActionsObj, "DANH_SACH_HOAN_TOT_NGHIEP");
export type IDanhSachHoanTotNghiepActionTypes = IGenericActionType<typeof eDanhSachHoanTotNghiepActionsObj, "DANH_SACH_HOAN_TOT_NGHIEP">;
